import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { magic } from "../lib/Magic";
import { UserContext } from "../lib/UserContext";
import EmailForm from "../components/EmailForm";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Login = () => {
  const navigate = useNavigate();
  const [disabled, setDisabled] = useState(false);
  const [account, setAccount] = useState('');
  const [user, setUser] = useContext(UserContext);

  // If user is already logged in, redirect to profile page
  useEffect(() => {
    user && user.issuer && navigate("/profile");
  }, [user, navigate]);

  async function handleLoginWithEmail(email: string) {
    try {
      setDisabled(true); // disable login button to prevent multiple emails from being triggered
      let didToken = await magic.auth.loginWithEmailOTP({email});
        if(didToken){
          const userMetadata = await magic.user.getMetadata();
          console.log("olde adress",userMetadata.publicAddress);
          setAccount(userMetadata.publicAddress);
          axios
          .post(
            `${process.env.REACT_APP_SERVER_URL}/auth`,
            {
              email: email,
            },
            {
              params: {
                magicAccount: userMetadata.publicAddress,
              },
            }
          )
          .then((response) => {
            if (response.data.Message == "login") {
              setUser({userId:response.data.data._id, userName:response.data.data.userName, magicLinkAccount:response.data.data.magicAccount, name:response.data.data.name, email:response.data.data.email, walletAddress: response.data.data.walletAddress, twitterUserName: response.data.data.twitterUserName, discordHandle: response.data.data.discordHandle})
              navigate("/profile");
            } else if (response.data.Message == "register") {
              setUser({email:email});
              navigate("/keep-in-touch");
            } else if (response.data.Message == "failed") {
              toast("Login Failed!");
            }
          });
        }
    } catch (error) {
      setDisabled(false); // re-enable login button - user may have requested to edit their email
      console.log(error);
    }
  }

  return (
    <>
    <ToastContainer toastStyle={{ backgroundColor: "#000000" }} />
      <div className="Login-header h-screen font-inter">
        <div className="px-6 pt-6 lg:px-8">
          <nav
            className="flex items-center justify-between"
          >
            <div className="flex lg:flex-1">
              <a href="#" className="-m-1.5 p-1.5">
                <span className="sr-only">Celium</span>
                <img className="h-14" src={"image/celium-white.png"} alt="celium-logo" />
              </a>
            </div>
          </nav>
        </div>
        <div className="container mx-auto">
          <div className="flex flex-col lg:flex-row gap-8">
            <div className="w-full lg:w-8/12 pt-10 sm:pt-40">
              <h1 className="text-5xl font-bold tracking-tight text-white sm:text-6xl font-inter">
                Start exploring decentralization with us
              </h1>
              <EmailForm
                disabled={disabled}
                onEmailSubmit={handleLoginWithEmail}
              />
            </div>
            <div className="w-full lg:w-4/12 p-5 sm:p-10">
              <img src={"image/celium-explorer.png"} className="h-auto" alt="celium-explorer" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
  
export default Login;
